import css from "../BtnsCloseAndSubmit/BtnsCloseAndSubmit.module.css";
import { FaCheck } from "react-icons/fa";

export default function BtnsCloseAndSubmit({
  onClose,
  handleSubmit,
  btnSave,
  btnClose,
}) {
  return (
    <div className={css.wrapper}>
      <button
        type="button"
        className={css.closeBtn}
        onClick={onClose}
        data-tour="step-5"
        data-tour-createrecord="step-5"
        data-tour-inwork="stepClientInfo-6.1"
      >
        {btnClose}
      </button>
      <button
        type="submit"
        className={css.submitBtn}
        onSubmit={handleSubmit}
        data-tour="step-4"
        data-tour-createrecord="step-4"
        data-tour-inwork="stepClientInfo-13"
      >
        <FaCheck className={css.submitBtnIcon} />
        {btnSave}
      </button>
    </div>
  );
}
